export const TOPOLOGY_MODEL = {
  标准模式: 'STANDARD',
  简单模式: 'SIMPLE',
};

export const TOPOLOGY_RELATION = {
  发起方: 'PUB',
  接收方: 'SUB',
};
